class PromiseConsumer {
    constructor(maxWorkers, consumables, action, consumablesFinishedAction) {
        this.consumables = consumables;
        this.numWorkers = 0;
        this.maxWorkers = maxWorkers;
        this.action = action;
        this.consumablesFinishedAction = consumablesFinishedAction;
        this.responses = [];
        this.finishedActions = 0;
        this.totalActions = consumables.length;
    }

    consume = () => {
        while (this.maxWorkers > this.numWorkers && this.consumables.length > 0) {
            this.numWorkers++;
            let currentElement = this.consumables.pop();
            this.action(currentElement, this.actionFinishedCallback);
        }
    }

    actionFinishedCallback = (response) => {
        if (response && response !== 'ko') {
            this.responses.push(response);
        }
        this.numWorkers--;
        this.finishedActions++;
        this.consume();
        if (this.totalActions === this.finishedActions) {
            if (this.consumablesFinishedAction) {
                this.consumablesFinishedAction(this.responses);
            }
        }
    }
}

export default PromiseConsumer;